export default "__VITE_ASSET__DhciuENR__"